// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  gc-steps .p-steps {
    position: relative;
  }
  gc-steps .p-steps ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: flex;
    overflow-x: auto;
    scrollbar-width: thin;
  }
  gc-steps .p-steps ul::-webkit-scrollbar {
    height: 0.25rem;
  }
  gc-steps .p-steps ul li > a {
    text-decoration: none !important;
    color: var(--gc-text-color) !important;
  }
  gc-steps .p-steps ul li > a .p-step-title {
    font-weight: 700;
  }
  gc-steps .p-steps ul li > a .p-step-number {
    padding: 0.2rem 0.7rem;
    border: 1px solid var(--gc-color-secondary);
  }
  gc-steps .p-steps-item {
    position: relative;
    display: flex;
    justify-content: center;
    flex: 1 0 200px;
  }
  gc-steps .p-steps-item .p-menuitem-link {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    text-decoration: none;
  }
  gc-steps .p-steps.p-steps-readonly .p-steps-item {
    cursor: auto;
  }
  gc-steps .p-steps-item.p-steps-current .p-menuitem-link {
    cursor: default;
  }
  gc-steps .p-step-title {
    white-space: nowrap;
  }
  gc-steps .p-step-number {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  gc-steps body:has(.hmm) .p-step-number {
    display: none;
  }
  gc-steps body:has(.hmm) .p-steps .p-steps-item:before {
    display: none;
  }
  gc-steps body:has(.hmm) .p-steps-item {
    flex: none;
    margin-right: 30px;
  }
  gc-steps body:has(.hmm) .p-steps-item a .p-step-title {
    padding: 0 0.25rem 0.1rem 0.25rem;
    border-bottom: 4px solid rgba(var(--gc-text-color-rgb), 0.25);
    font-weight: 400;
  }
  gc-steps body:has(.hmm) .p-steps-item.p-highlight.p-steps-current a .p-step-title {
    font-weight: 400;
    border-bottom: 4px solid var(--gc-color-primary);
  }
  gc-steps body:has(.hmm) .p-steps .p-steps-item .p-menuitem-link .p-step-title {
    color: var(--gc-text-color);
  }
  gc-steps .p-step-title {
    display: block;
  }
  gc-steps .p-steps {
    margin-top: 1rem;
  }
  gc-steps .p-steps .p-steps-item.gc-visited .p-menuitem-link .p-step-number {
    background: var(--gc-color-secondary-tint) !important;
    color: var(--gc-text-color);
  }
  gc-steps .p-steps .p-steps-item.p-highlight .p-menuitem-link .p-step-number {
    background: var(--gc-color-success) !important;
    color: var(--gc-text-color);
  }
  gc-steps .p-steps .p-steps-item.gc-invalid .p-menuitem-link .p-step-number {
    background: var(--gc-color-danger) !important;
    color: var(--gc-text-color-inverse);
  }
  gc-steps .p-steps .p-steps-item .p-menuitem-link {
    cursor: pointer;
  }
  gc-steps .p-steps .p-steps-item .p-menuitem-link:not(.p-disabled):focus {
    box-shadow: none;
  }
  gc-steps .p-steps .p-steps-item .p-menuitem-link .p-step-number {
    border-radius: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ngx-components/lib/wrappers/components/step/step.sass"],"names":[],"mappings":"AAAA;EAEQ;IACI,kBAAA;EAAV;EAGM;IAGI,UAAA;IACA,SAAA;IACA,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,qBAAA;EAHV;EAJU;IACI,eAAA;EAMd;EACU;IACI,gCAAA;IACA,sCAAA;EACd;EAAc;IACI,gBAAA;EAElB;EADc;IACI,sBAAA;IACA,2CAAA;EAGlB;EADM;IACI,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,eAAA;EAGV;EAAM;IACI,oBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,qBAAA;EAEV;EACM;IACI,YAAA;EACV;EACM;IACI,eAAA;EACV;EAEM;IACI,mBAAA;EAAV;EAGM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;EADV;EAIU;IACI,aAAA;EAFd;EAGU;IACI,aAAA;EADd;EAKU;IACI,UAAA;IACA,kBAAA;EAHd;EAKkB;IACI,iCAAA;IACA,6DAAA;IACA,gBAAA;EAHtB;EAMkB;IACI,gBAAA;IAEA,gDAAA;EALtB;EAMU;IACI,2BAAA;EAJd;EAKM;IACI,cAAA;EAHV;EAKM;IACI,gBAAA;EAHV;EAOsB;IACI,qDAAA;IACA,2BAAA;EAL1B;EAQsB;IACI,8CAAA;IACA,2BAAA;EAN1B;EASsB;IACI,6CAAA;IACA,mCAAA;EAP1B;EAQc;IACI,eAAA;EANlB;EAOkB;IACI,gBAAA;EALtB;EAMkB;IACI,kBAAA;EAJtB;AACF","sourcesContent":["@layer vierkant\n    gc-steps\n        .p-steps \n            position: relative\n\n\n        .p-steps ul \n            &::-webkit-scrollbar\n                height: 0.25rem\n            padding: 0\n            margin: 0\n            list-style-type: none\n            display: flex\n            overflow-x: auto\n            scrollbar-width: thin\n            li > a\n                text-decoration: none !important\n                color: var(--gc-text-color) !important\n                .p-step-title\n                    font-weight: 700\n                .p-step-number\n                    padding: 0.20rem 0.70rem\n                    border: 1px solid var(--gc-color-secondary) \n\n        .p-steps-item \n            position: relative\n            display: flex\n            justify-content: center\n            flex: 1 0 200px\n\n\n        .p-steps-item .p-menuitem-link \n            display: inline-flex\n            flex-direction: column\n            align-items: center\n            overflow: hidden\n            text-decoration: none\n\n\n        .p-steps.p-steps-readonly .p-steps-item \n            cursor: auto\n\n        .p-steps-item.p-steps-current .p-menuitem-link \n            cursor: default\n\n\n        .p-step-title \n            white-space: nowrap\n\n\n        .p-step-number \n            display: flex\n            align-items: center\n            justify-content: center\n\n        body:has(.hmm)\n            .p-step-number \n                display: none\n            .p-steps .p-steps-item:before\n                display: none\n                // content: \"\\2192\"\n                // font-size: 1.5rem\n                // border: none\n            .p-steps-item\n                flex: none\n                margin-right: 30px\n                a\n                    .p-step-title\n                        padding: 0 0.25rem 0.1rem 0.25rem\n                        border-bottom: 4px solid rgba(var(--gc-text-color-rgb), 0.25)\n                        font-weight: 400\n            .p-steps-item.p-highlight.p-steps-current\n                a\n                    .p-step-title\n                        font-weight: 400\n                        // padding: 0 0.25rem 0.1rem 0.25rem\n                        border-bottom: 4px solid var(--gc-color-primary)\n            .p-steps .p-steps-item .p-menuitem-link .p-step-title\n                color: var(--gc-text-color)\n        .p-step-title \n            display: block\n\n        .p-steps\n            margin-top: 1rem\n            .p-steps-item\n                &.gc-visited\n                    .p-menuitem-link\n                        .p-step-number\n                            background: var(--gc-color-secondary-tint) !important\n                            color: var(--gc-text-color)\n                &.p-highlight\n                    .p-menuitem-link\n                        .p-step-number\n                            background: var(--gc-color-success) !important\n                            color: var(--gc-text-color)\n                &.gc-invalid\n                    .p-menuitem-link\n                        .p-step-number\n                            background: var(--gc-color-danger) !important\n                            color: var(--gc-text-color-inverse)\n                .p-menuitem-link\n                    cursor: pointer\n                    &:not(.p-disabled):focus\n                        box-shadow: none\n                    .p-step-number\n                        border-radius: 50%"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
